import type { Word } from "@/types/word";
import { WordCard } from "./WordCard";

interface WordsListProps {
  groupedWords: Record<string, Word[]>;
}

export const WordsList = ({ groupedWords }: WordsListProps) => {
  const sortedLetters = Object.keys(groupedWords).sort();

  return (
    <div className="space-y-8">
      {sortedLetters.map((letter) => (
        <section key={letter} className="animate-slide-up">
          <div className="sticky top-24 z-10 py-2 mb-4">
            <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-primary text-primary-foreground text-2xl font-bold shadow-lg">
              {letter}
            </span>
          </div>
          <div className="grid gap-4">
            {groupedWords[letter]
              .sort((a, b) => a.word.localeCompare(b.word))
              .map((word, index) => (
                <WordCard key={`${word.word}-${index}`} word={word} />
              ))}
          </div>
        </section>
      ))}
    </div>
  );
};
